module.exports = load = {
	asset : ( url, type, callback, after, options ) => {
		if( load.confirm( url ) ) return;
		//default to script tag if not specified (supports link/script )
		type = type || 'script';
		after = after || true;
		options = options || {};
		//Find first script tag
		
		var tag = window.document.createElement( type );
		//stylesheet settings
		if( type === 'link' ) {
			tag.rel = 'stylesheet'; 
			tag.href = url;
		}

		if( type === 'script' ) {
			tag.src = url;
			tag.async = true;
			tag.defer = true;
		}

		if( options.hasOwnProperty( 'attributes' ) ) {
			attributes = Object.entries( options.attributes );
			for (const [attribute, value] of attributes) {
				tag.setAttribute(attribute, value);
			}
		}

		tag.onload = function() {
			window.loaded = window.loaded || [];
			window.loaded.push( url );
			typeof callback === 'function' ? callback() : false;
		}

		if( !after ) {
			var firstScript = window.document.getElementsByTagName('script')[0];
			firstScript.parentNode.insertBefore(tag, firstScript);
		} else {
			document.body.insertBefore(tag,document.body.lastChild);
		}
		
		return tag;
	},
	checkDependencies : ( list, callback ) => {
		// console.log('loop', list, callback)
		let loaded = true;
		list.forEach( dep => {
			if( !load.confirm(dep.src) ) { loaded = false };
			// console.log( 'dep loaded', dep )
		} )
		if( loaded ) {
			typeof callback === 'function' ? callback() : false;
		}
        
	},
	dependencies : ( list, callback ) => {
		list.forEach( dep => {
			if( !dep.state || dep.state != 'loading' ) {
				const type = dep.type || false; 
				dep.state = 'loading';
				load.asset(dep.src, type, load.checkDependencies.bind( null, list, callback ), true);
			}
		})
	},
	confirm : ( script ) => {
		window.loaded = window.loaded || [];
		return window.loaded.includes(script);
	}
}